import { api, APP_ID } from './client';
import type {
  LoginCredentials,
  LoginResponse,
} from '@/types/auth';

export async function login(credentials: LoginCredentials): Promise<LoginResponse> {
  return api.post<LoginResponse>('/auth/login/', {
    user_id: credentials.userId,
    password: credentials.password,
    app_id: credentials.appId || APP_ID,
  });
}

export async function logout(): Promise<void> {
  return api.get<void>('/auth/logout/');
}
